import React, { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CRMReportingContext = createContext(null);

export function CRMReportingProvider({ children }) {
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadPacks = useCallback(async (projectId) => {
    if (!projectId) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/projects/${projectId}/crm-reporting-packs`);
      setPacks(data);
    } catch {
      setPacks([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const createPack = useCallback(async (projectId, payload) => {
    const { data } = await api.post(`/projects/${projectId}/crm-reporting-packs`, payload);
    setPacks((prev) => [data, ...prev]);
    return data;
  }, []);

  const updatePack = useCallback(async (packId, updates) => {
    const { data } = await api.patch(`/crm-reporting-packs/${packId}`, updates);
    setPacks((prev) => prev.map((p) => (p.id === packId ? data : p)));
    return data;
  }, []);

  return (
    <CRMReportingContext.Provider value={{ packs, loading, loadPacks, createPack, updatePack }}>
      {children}
    </CRMReportingContext.Provider>
  );
}

export function useCRMReporting() {
  const ctx = useContext(CRMReportingContext);
  if (!ctx) throw new Error("useCRMReporting must be used within CRMReportingProvider");
  return ctx;
}
